const CharacteristicsAccordion = () => {
  const filterCharacteristicsList = [...document.querySelectorAll(".filter__characteristics")];

  if (filterCharacteristicsList.length > 0) {
    filterCharacteristicsList.forEach((filterCharacteristicsItem) => {
      const opener = filterCharacteristicsItem.querySelector(".filter__characteristics-more-btn");
      const characteristicsList = filterCharacteristicsItem.querySelector(".filter__characteristics-list-wrapper");

      if (opener) {
        opener.addEventListener("click", () => {
          characteristicsList.classList.toggle("opened");
          opener.classList.toggle("opened");
        })
      }
    })
  }
}

export default CharacteristicsAccordion

